import React, { useState, useEffect, useContext } from "react";
import {
  Box,
  Button,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Typography,
  TextField,
  Divider,
} from "@mui/material";
import { InputAdornment, IconButton } from "@mui/material";
import ClearIcon from "@mui/icons-material/Clear";
import { ThemeContext } from "../../Homepage";
import {
  getMeterMetrics,
  getMeterDevices,
  getTagsForDevices,
} from "../../../Restclient/datacollection";
import CustomButton from "../../CommonComponents/CustomButton";
import { useDispatch, useSelector } from "react-redux";
import CustomActionButton from "../../CommonComponents/CustomActionButton";
import { setPage } from "../../../store/pageselect_data";
import {
  setSelectedTab,
  updateconfigtreepathselected,
} from "../../../store/cofig_data";
import {
  updateAddDevice,
  setEditDeviceData,
} from "../../../store/device_config_data";
import CustomDialogBox from "../../CommonComponents/CustomDialogBox";
import "../../../cssfiles/billing.css";
import SearchIcon from "../../../images/LK_Search";

const MeterActions = ({
  device,
  setDeviceList,
  setMeterInfo,
  setOpenForm,
  setFormMode,
}) => {
  const [openConfirm, setOpenConfirm] = useState(false);
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const handleViewClick = () => {
    if (!device) {
      alert("Cannot view device - missing data");
      return;
    }

    const deviceToView = {
      id: device.DeviceID,
      data: {
        serialNumber: device.SN || "",
        name: device.Name || "",
        manufacturer: device.Make || "",
        isActive: device.Enable || false,
        deviceType: device.DeviceType?.DeviceTypeID || "",
      },
    };

    setMeterInfo(deviceToView);
    setFormMode("view");
    setOpenForm(true);
  };

  const handleUpdateClick = () => {
    dispatch(setPage("config"));
    dispatch(updateconfigtreepathselected(["Device"]));
    dispatch(setSelectedTab({ tab: "Device", value: 0 }));
    dispatch(setEditDeviceData(1));
  };

  const handleDeleteClick = () => {
    setOpenConfirm(true);
  };

  const handleDelete = () => {
    setLoading(true);
    setTimeout(() => {
      setDeviceList((prev) =>
        prev.filter((d) => d.DeviceID !== device.DeviceID),
      );
      setOpenConfirm(false);
      setLoading(false);
    }, 1000);
  };

  return (
    <>
      <Box className="meter-actions-container">
        <CustomActionButton buttonText={"View"} onClick={handleViewClick} />
        <CustomActionButton buttonText={"Delete"} onClick={handleDeleteClick} />
        <CustomActionButton buttonText={"Update"} onClick={handleUpdateClick} />
      </Box>
      <CustomDialogBox
        dialogTitle={"Delete Confirmation"}
        dialogText={`Are you sure you want to delete this device? This action cannot be undone.`}
        openDialog={openConfirm}
        handleCloseDialog={() => setOpenConfirm(false)}
        handleConfirmDialog={handleDelete}
        confirmText={"Delete"}
        cancelText={"Cancel"}
        type={"Warning"}
        loading={loading}
      />
    </>
  );
};

const MeterMetrics = () => {
  const [metrics, setMetrics] = useState({
    totalMeters: 0,
    activeMeters: 0,
    inactiveMeters: 0,
  });
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchMetrics = () => {
      setIsLoading(true);
      getMeterMetrics((response) => {
        if (response?.state && response.metrics) {
          setMetrics({
            totalMeters: response.metrics.totalMeters ?? 0,
            activeMeters: response.metrics.activeMeters ?? 0,
            inactiveMeters: response.metrics.inactiveMeters ?? 0,
          });
        }
        setIsLoading(false);
      }, "Meter");
    };

    fetchMetrics();
  }, []);

  const metricsData = [
    {
      label: "Total Meters",
      value: metrics.totalMeters,
      color: "var(--PrimaryText)",
    },
    {
      label: "Active Meters",
      value: metrics.activeMeters,
      color: "var(--GreenBaseColor)",
    },
    {
      label: "Inactive Meters",
      value: metrics.inactiveMeters,
      color: "var(--GreyBaseColor)",
    },
  ];

  return (
    <div className="meter-metrics-card card2">
      <div className="meter-metrics-container">
        {metricsData.map((metric, index) => (
          <React.Fragment key={index}>
            <div className="meter-metric-item cardtext">
              <div>
                <Typography className="meter-metric-label">
                  {metric.label}
                </Typography>
              </div>
              <div>
                <Typography
                  className="meter-metric-value"
                  style={{ color: metric.color }}
                >
                  {metric.value}
                </Typography>
              </div>
            </div>
            {index < metricsData.length - 1 && (
              <Divider
                orientation="vertical"
                variant="middle"
                className="meter-metric-divider"
                flexItem
              />
            )}
          </React.Fragment>
        ))}
      </div>
    </div>
  );
};

export default function UtilityMeterDashboard(props) {
  const themechange = useSelector((state) => state.themedata.theme);
  const [isLoading, setIsLoading] = useState(false);
  const [search, setSearch] = useState({ searchText: "", filterSelected: "" });
  const [isSearching, setIsSearching] = useState(false);
  const [searchList, setSearchList] = useState([]);
  const userdetails = useSelector((state) => state.logindata.userdetails);
  const dispatch = useDispatch();
  const [deviceList, setDeviceList] = useState([]);
  const [openForm, setOpenForm] = useState(false);
  const [formMode, setFormMode] = useState("add");
  const [meterInfo, setMeterInfo] = useState({});
  const { theme } = useContext(ThemeContext);

  const handleOpen = () => {
    dispatch(setPage("config"));
    dispatch(updateconfigtreepathselected(["Device"]));
    dispatch(setSelectedTab({ tab: "Device", value: 0 }));
    dispatch(updateAddDevice(1));
  };

  // useEffect(() => {
  //   const orgId = userdetails?.organizationId || "default-org";
  //   const projectId = userdetails?.projectId || "default-project";

  //   getMeterDevices(orgId, projectId, (response) => {
  //     const devices = response.devices || [];
  //     const meterDevices = devices.filter(
  //       (device) =>
  //         device.DeviceType && device.DeviceType.DeviceTypeID === "Meter"
  //     );

  //     setDeviceList(meterDevices);
  //     setIsLoading(false);

  //     const deviceIds = meterDevices.map((d) => d.DeviceID);
  //     if (deviceIds.length > 0) {
  //       getTagsForDevices(deviceIds, (tagResponse) => {});
  //     }
  //   });
  // }, [userdetails]);
  useEffect(() => {
    const fetchMeterDevices = () => {
      setIsLoading(true);
      getMeterDevices((response) => {
        let devices = [];
        if (response?.devices && Array.isArray(response.devices)) {
          devices = response.devices;
        }

        const meterDevices = devices.filter((device) => {
          const devTypeID = device?.DeviceType?.DeviceTypeID;
          return devTypeID && devTypeID !== "" && devTypeID !== "Meter1"; // correct filtering
        });

        setDeviceList(meterDevices);
        setIsLoading(false);
      });
    };

    fetchMeterDevices();
  }, [userdetails]);

  const handleSearchClick = async () => {
    try {
      setIsLoading(true);
      const filteredDevices = deviceList.filter((device) => {
        const serialNumber = device.SN || device.DeviceID;
        const deviceName = device.Name || "";

        if (!serialNumber && !deviceName) {
          return false;
        }

        const searchText = search.searchText.toLowerCase();
        const isMatch =
          serialNumber.toString().toLowerCase().includes(searchText) ||
          deviceName.toLowerCase().includes(searchText);

        return isMatch;
      });

      setSearchList(filteredDevices);
      setIsSearching(true);
    } catch (err) {
      console.error("Search error:", err);
    } finally {
      setIsLoading(false);
    }
  };

  const handleSearchCancel = () => {
    setSearch({ searchText: "", filterSelected: "" });
    setSearchList([]);
    setIsSearching(false);
  };

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      handleSearchClick();
    }
  };

  const displayDevices = isSearching ? searchList : deviceList;

  return (
    <Box
      className={`meter-dashboard-container meter-dashboard-container--${themechange}`}
    >
      <MeterMetrics />

      <Box className="header-container">
        <Box></Box>
        <Box className="search-actions-container">
          <TextField
            size="small"
            placeholder="Search by Serial Number or Name"
            variant="standard"
            value={search.searchText}
            onChange={(e) =>
              setSearch({ ...search, searchText: e.target.value })
            }
            onKeyPress={handleKeyPress}
            InputProps={{
              endAdornment: search.searchText ? (
                <InputAdornment position="end">
                  <IconButton
                    edge="end"
                    onClick={handleSearchCancel}
                    size="small"
                  >
                    <ClearIcon fontSize="small" />
                  </IconButton>
                </InputAdornment>
              ) : null,
            }}
            className={`search-field search-field--${themechange}`}
          />
          <IconButton
            onClick={handleSearchClick}
            style={{
              fontSize: "12px",
              width: "30px",
              minWidth: "30px",
              fontWeight: 400,
              color: "var(--Searchtext_muted)",
              fontFamily: "Roboto",
              textAlign: "left",
              justifySelf: "right",
              cursor: "pointer",
              textTransform: "none",
              marginLeft: "0px",
              padding: 0,
            }}
          >
            <SearchIcon
              color={theme === "light" ? "#3C3C3C" : "#C1C1C1"}
              width={30}
              height={30}
            />
          </IconButton>
          <CustomButton buttonText={"+Add Meter"} onClick={handleOpen} />
        </Box>
      </Box>

      <TableContainer
        component={Paper}
        className="table-container"
        elevation={0}
      >
        <Table stickyHeader className="customers-table" size="small">
          <TableHead>
            <TableRow className="table-header-row">
              <TableCell
                className="table-header-cell"
                sx={{
                  fontSize: props.widgetprop.props.extended.tablehead.fontsize,
                  fontWeight:
                    props.widgetprop.props.extended.tablehead.fontweight,
                }}
              >
                Serial Number
              </TableCell>
              <TableCell
                className="table-header-cell"
                sx={{
                  fontSize: props.widgetprop.props.extended.tablehead.fontsize,
                  fontWeight:
                    props.widgetprop.props.extended.tablehead.fontweight,
                  maxWidth: "200px",
                }}
              >
                Meter Name
              </TableCell>
              <TableCell
                className="table-header-cell"
                sx={{
                  fontSize: props.widgetprop.props.extended.tablehead.fontsize,
                  fontWeight:
                    props.widgetprop.props.extended.tablehead.fontweight,
                  maxWidth: "150px",
                }}
              >
                Manufacturer
              </TableCell>
              <TableCell
                className="table-header-cell"
                sx={{
                  fontSize: props.widgetprop.props.extended.tablehead.fontsize,
                  fontWeight:
                    props.widgetprop.props.extended.tablehead.fontweight,
                }}
              >
                Status
              </TableCell>
              <TableCell
                className="table-header-cell"
                sx={{
                  fontSize: props.widgetprop.props.extended.tablehead.fontsize,
                  fontWeight:
                    props.widgetprop.props.extended.tablehead.fontweight,
                }}
              >
                Actions
              </TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {displayDevices && displayDevices.length > 0 ? (
              displayDevices.map((device) => (
                <TableRow key={device.DeviceID} className="table-body-row">
                  <TableCell
                    component="th"
                    scope="row"
                    className="table-body-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablerows.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablerows.fontweight,
                    }}
                  >
                    {device.SN || "N/A"}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    className="table-body-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablerows.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablerows.fontweight,
                      maxWidth: "200px",
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      textOverflow: "ellipsis",
                    }}
                  >
                    {device.Name || "N/A"}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    className="table-body-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablerows.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablerows.fontweight,
                    }}
                  >
                    {device.Make || "N/A"}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    className={`meter-status-cell meter-status-cell--${
                      device.Enable ? "active" : "inactive"
                    }`}
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablerows.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablerows.fontweight,
                    }}
                  >
                    {device.Enable ? "Active" : "Inactive"}
                  </TableCell>
                  <TableCell
                    component="th"
                    scope="row"
                    className="table-body-cell"
                    sx={{
                      fontSize:
                        props.widgetprop.props.extended.tablerows.fontsize,
                      fontWeight:
                        props.widgetprop.props.extended.tablerows.fontweight,
                    }}
                  >
                    <MeterActions
                      device={device}
                      setDeviceList={setDeviceList}
                      setMeterInfo={setMeterInfo}
                      setOpenForm={setOpenForm}
                      setFormMode={setFormMode}
                    />
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} className="no-data-cell">
                  {isLoading ? "Loading devices..." : "No devices found"}
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
    </Box>
  );
}
